import Vue from 'vue'
import { mutateAll } from '@/store/utils'
import { createInitialState } from './index'

export const setTransportOrders = (state, payload) => {
  Vue.set(state, 'transportOrders', {
    ...state.transportOrders,
    ...payload,
    updatesCount: 0
  })
}

export const setOrderDetails = (state, payload) => {
  Vue.set(state, 'orderDetails', payload)
}

export const setDispatchingConfirmationDetails = (state, payload) => {
  Vue.set(state, 'dispatchingConfirmation', payload)
}

export const canSubmitFiles = (state, canSubmitFiles) => {
  Vue.set(state, 'canSubmitFiles', canSubmitFiles)
}

export const setPodDocuments = (state, documents) => {
  state.podDocuments = documents.map(doc => ({ ...doc, isBeingRemoved: false }))
}

export const setPodProcessStatus = (state, podProcessStatus) => {
  state.podProcessStatus = podProcessStatus
}

export const addPodDocument = (state, document) => {
  state.podDocuments.splice(0, 0, {
    ...document,
    state: 'UPLOADING',
    created: null,
    error: null,
    isBeingRemoved: false
  })
}

export const setPodDocumentError = (state, { localId, error }) => {
  const index = state.podDocuments.findIndex(file => file.localId === localId)
  state.podDocuments[index].error = error
  state.podDocuments[index].state = 'ERROR'
  state.podDocuments[index].created = new Date()
}

export const setPodDocumentAsUploaded = (state, localId) => {
  const index = state.podDocuments.findIndex(file => file.localId === localId)
  // if the document is being removed while uploading, state.podDocuments[index] will be undefined
  // and code below will throw an error, so "if" statement is needed here
  if (index !== -1) {
    state.podDocuments[index].created = new Date()
    state.podDocuments[index].state = 'UPLOADED'
  }
}

export const setPodDocumentAsBeingRemoved = (state, { document, isBeingRemoved }) => {
  const index = state.podDocuments.findIndex(file => file.id === document.id)
  state.podDocuments[index].isBeingRemoved = isBeingRemoved
}

const removePodDocumentByLocalId = (state, localId) => {
  state.podDocuments = state.podDocuments.filter(iter => iter.localId !== localId)
}

const removePodDocumentById = (state, id) => {
  state.podDocuments = state.podDocuments.filter(iter => iter.id !== id)
}

export const removePodDocument = (state, document) => {
  const { localId, id } = document
  if (id) removePodDocumentById(state, id)
  else removePodDocumentByLocalId(state, localId)
}

export const setPodError = (state, error) => {
  state.podError = error
}

export const setInProgressPodStepTransition = (state, value) => {
  state.podInProgressTransition = value
}

export const setMissingDocuments = (state, documents) => {
  state.missingDocuments = documents.map(doc => ({ type: doc.document_type }))
}

export const reset = state => {
  mutateAll(state, createInitialState())
}

export const setCarrierAbleToUploadPodDocuments = (state, value) => {
  state.ableToUploadPodDocuments = value
}
